
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/video/[id]",
      function () {
        return require("private-next-pages/pelatihan-mandiri/video/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pelatihan-mandiri/video/[id]"])
      });
    }
  